const clientRoutes = {
  clientDashboard: {
    path: '/dashboard'
  },
  myPlanStatus: {
    path: '/my-plan'
  },
  planDetail: {
    path: '/plan-detail/:id'
  },
  subscriptionCheckout: {
    path: '/checkout/subscribe/:id'
  },
  clientMore: {
    path: '/more'
  },
  clientProfile: {
    path: '/profile'
  },
  joinOrganization: {
    path: '/my-organization'
  },
  myWellbeing: {
    path: '/my-wellbeing'
  },
  listClient: {
    path: '/users/clients'
  },
  createClient: {
    path: '/users/clients/create'
  },
  editClient: {
    path: '/users/clients/edit/:id'
  },
  viewClient: {
    path: '/users/clients/:id'
  }
};

export default clientRoutes;
